<!--水费账单-->
<template>
  <div style="height: 100%;background-color: white;">
    <div style="height: 100%;">
      <div class="searchContainer">
        <el-form ref="form" label-width="90px" style="display: flex;align-items: center;flex-wrap: wrap;">
          <el-form-item label="业主姓名">
            <input type="text" v-model="ownerName" maxlength="20" placeholder="请输入业主姓名" style="width: 100px;" />
          </el-form-item>
          <el-form-item label="抄表日期">
            <el-date-picker @change="getDataList" value-format="timestamp" size="small" v-model="datetimeValue"
              style="width: 310px;" type="datetimerange" :picker-options="pickerOptions" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="缴费状态">
            <singleSelection class="singleSelection" style="width: 110px;" :nameKey="'text'" :list="chargingStatusList"
              :autoCheck="0" @checkItem="selectState($event)"></singleSelection>
          </el-form-item>
          <el-form-item label="电表类型">
            <singleSelection class="singleSelection" :nameKey="'text'" :list="meterRunTypeList" :autoCheck="0"
              @checkItem="selectMeterRunType($event)"></singleSelection>
          </el-form-item>
          <el-form-item label="账单类型">
            <singleSelection class="singleSelection" :nameKey="'text'" :list="accountTypeList" :autoCheck="1"
              @checkItem="selectAccountType($event)"></singleSelection>
            <el-button type="primary" size="mini" @click="getDataList">查询</el-button>
            <el-button type="primary" size="mini" @click="exportReport">账单导出</el-button>
          </el-form-item>


        </el-form>
      </div>

      <div class="infoListContainer">
        <el-table :data="dataList" height="750" border style="width: 100%;height: 94%;">
          <template slot="empty">
            <span class="noData">
              <img src="../../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="50" fixed align="center">
          </el-table-column>
          <el-table-column prop="userName" label="业主姓名" align="center">
            <template slot-scope="scope">
              {{editOwnerName(scope.row.userName)}}
            </template>
          </el-table-column>
          <el-table-column prop="meterRunType" label="表类型" align="center">
            <template slot-scope="scope">
              {{editMeterRunType(scope.row.meterRunType)}}
            </template>
          </el-table-column>
          <el-table-column prop="accountType" label="付费类型" align="center">
            <template slot-scope="scope">
              <span class="normalStatus" v-show="scope.row.accountType == '0'">月结</span>
              <span v-show="scope.row.accountType == undefined || scope.row.accountType == ''">-</span>
              <span class="normalStatus" v-show="scope.row.accountType == '1'">预付费</span>
              <span class="normalStatus" v-show="scope.row.accountType == '2'">预付费-月账单</span>
            </template>
          </el-table-column>
          <el-table-column prop="Time" label="实际用水时间" width="330" />
          <el-table-column prop="beginMeterReading" label="上次抄表" />
          <el-table-column prop="endMeterReading" label="本次抄表" />
          <el-table-column prop="electricQuantity" label="用水量(m³)" width="120" />
          <el-table-column prop="electricFee" label="水费(元)">
            <template slot-scope="scope">
              <span>{{scope.row.electricFee /100}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="basicFee" label="基本水费(元)" width="140">
            <template slot-scope="scope">
              <span>{{scope.row.basicFee /100}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="合计(元)">
            <template slot-scope="scope">
              <span>{{scope.row.amount /100}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="minUserBalance" label="上次余额(元)" width="160">
            <template slot-scope="scope">
              <span>{{scope.row.maxUserBalance /100}}</span>

            </template>
          </el-table-column>
          <el-table-column prop="maxUserBalance" label="本次余额(元)" width="160">
            <template slot-scope="scope">
              <span>{{scope.row.minUserBalance /100}}</span>
            </template>
          </el-table-column>


          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <span class="operateBtn" :class="{'noDrop':isNaN(parseInt(scope.row.state))}"
                v-if="parseInt(scope.row.state) == 0 && scope.row.accountType == '0'" @click="onOffState(scope.row)">结
                算</span>
              <span class="operateBtn" v-show="scope.row.amount >0" v-else
                @click="viewOrderDetails(scope.row)">账单详情</span>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <elPagination :total="totalSize" :pageSize="pageSize" @pageindexChange="jumpToPage"
          @handleSizeChange="pageSizeChange" />
      </div>

    </div>
    <billDialog ref="billDialog"></billDialog>
  </div>
</template>

<script>
  import infoListMultipleSelection from '@/page/system/meterReading/infoListMultipleSelection.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import billDialog from './waterBillDialog.vue'
  import waterBillStore from './waterBillStore'
  import billStore from "./waterOrderDetailbillStore";
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  import request from "@/api/http.js";

  export default {
    components: {
      elPagination,
      infoListMultipleSelection,
      billDialog,
      singleSelection,
    },
    props: {},
    data () {
      return {
        pageIndex: 1,
        pageSize: 20,
        totalSize: 100,
        dataList: [],
        deviceNos: '',
        ownerName: '',
        state: undefined,
        filterTime: false,
        searchChange: false,
        accountType: 1,
        meterRunType: 2,
        meterType: "water",
        billingMode: '',
        datetimeValue: [new Date().getTime()-3600*1000*24*31,new Date().getTime()],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*7);
              picker.$emit('pick',[start,end]);
            }
          },{
            text: '最近三个月',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*92);
              picker.$emit('pick',[start,end]);
            }
          }]
        },
      }
    },
    created () {},
    mounted () {
      this.getDataList();

    },
    destroyed () {},
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowTimeInterval () {
        return this.$store.cacheStore.getters.getBillTimeInterval
      },
      nowDateText () {
        return this.filterTime? this.nowTimeInterval.startDate.formatByDate()+' - '+this.nowTimeInterval.endDate.formatByDate():''
      },
      columns () {
        return billStore.state.columns
      },
      editOwnerName () {
        return userName => {
          return userName==null||userName==''||userName==undefined? '-':userName
        }
      },
      editMeterRunType () {
        return meterRunType => {
          return meterRunType==1? '预付费表':'远控表';
        }
      },

      chargingStatusList () {
        return billStore.state.chargingStatusList
      },
      accountTypeList () {
        return billStore.state.accountTypeList
      },
      meterRunTypeList () {
        return billStore.state.meterRunTypeList
      },
      timeText () {
        return time => {
          if(time==null||time==undefined||time=='') {
            return '-'
          }
          return new Date(time).formatByTime()
        }
      },
    },
    watch: {
      nowUnit (nv,ov) {
        billStore.commit('setNowUnit',nv)
        this.getDataList(nv)
      },
      ownerName (nv,ov) {
        this.searchChange=true
      },
      state (nv,ov) {
        this.searchChange=true
      },
      filterTime (nv,ov) {
        this.searchChange=true
      },
      nowTimeInterval (nv,ov) {
        this.searchChange=true
        this.getDataList()
      }
    },
    methods: {
      selectState (item) {
        if(item.value==-3) {
          this.state=undefined
        } else {
          this.state=item.value
        }
      },
      selectAccountType (item) {
        this.accountType=item.value
      },
      selectMeterRunType (item) {
        //debugger
        this.meterRunType=item.value
      },
      //结算
      onOffState (item) {
        if(isNaN(parseInt(item.state))) {
          return
        }
        //var state = parseInt(item.state) == 1 ? 0 : 1
        this.$refs.billDialog.open(data => {
          this.$api.meterReadingApi.manualClearing(item.pkid,data.fee*100,data.password,respon => {
            this.$dialogMethod.showMessage('操作成功')
            this.getDataList()
          },err => {
            this.$dialogMethod.showMessage(err)
          })
        })
      },

      //账单详情页面
      viewOrderDetails (e) {
        //debugger
        this.$router.push(
          {
            name: 'orderDetailListReport',query:

            {
              userId: e.targetId,
              meterType: this.meterType,
              meterRunType: this.meterRunType,
              accountType: this.accountType,
              datetimeValue: this.datetimeValue,
              billingMode: e.billingMode
            }

          })
      },

      openOwnerInfoViewDialog (userData) {
        ownerManagerStore.state.nowOwnerInformation=userData
        this.$router.push('/ownerManagerView')
      },

      //排序
      compare (name) {
        return function(a,b) {
          //debugger
          var s1=a[name]+"";
          var s2=b[name]+"";
          return s1.localeCompare(s2);
        }
      },
      // 获取列表信息
      getDataList () {

        $(".typechoice").css("color","black");

        if(isempty(this.nowUnit)) {
          return
        }
        if(isempty(this.datetimeValue)) {
          this.datetimeValue=['','']
        }
        //debugger
        if(isempty(this.accountType)||isempty(this.meterRunType)) {
          this.$dialogMethod.showMessage("需选择水表类型与付费类型!")
          $(".typechoice").css("color","red");
          return false
        }

        if(this.searchChange) {
          this.pageIndex=1
          this.$refs.meterManagerList.pageIndex=1
          this.searchChange=false
        }
        this.$api.meterReadingApi.getHandleElectricityBill(this.meterType,this.nowUnit.id,this.pageIndex,this.pageSize,this.deviceNos,this.ownerName,this.state,this.datetimeValue[0],this.datetimeValue[1],this.accountType,this.meterRunType,respon => {
          this.dataList=copy(respon.dataList.sort(this.compare('createTime')))
          for(var i=0;i<respon.dataList.length;i++) {
            this.dataList[i]['Time']=this.timeText(respon.dataList[i].beginTime)+' - '+this.timeText(respon.dataList[i].endTime)
          }
          this.totalSize=respon.total
          this.$refs.meterManagerList.totalSize=respon.total
        })
      },

      // 获取订单列表信息
      getOrderDataList () {
        //debugger
        if(isempty(this.nowUnit)) {
          return
        }
        if(this.searchChange) {
          this.pageIndex=1
          this.searchChange=false
        }
        //对参数给值
        this.$api.meterReadingApi.getUnitMeterReadingConfigLimit(this.nowUnit.id,this.pageIndex,this.pageSize,this.deviceNo,null,this.ownerName,this.state,this.state232,this.deviceState,this.deductionFeeDay,null,respon => {
          //console.info(999);
          this.dataList=copy(respon.dataList.sort(this.compare('createTime')))
          this.total=respon.total
        })
      },

      // 导出报表
      exportReport () {
        if(isempty(this.datetimeValue)) {
          this.datetimeValue=['','']
        }
        var title=this.nowUnit.name+'账单信息'
        var params={
          meterRunType: this.meterRunType,
          meterType: this.meterType,
          unitid: this.nowUnit.id,
          deviceNos: this.deviceNos,
          ownerName: this.ownerName,
          beginTime: this.datetimeValue[0],
          endTime: this.datetimeValue[1],
          accountType: this.accountType
        }

        // Get请求
        request({url: "/meterReading/exportWaterBill.do",method: "get",params}).then(res => {
          console.log(res,'res');
          saveAs(DWSystemSetting.downloadUrl+'/'+res.data,title+".xls")
        })


        // this.$api.meterReadingApi.exportElectricityBill(this.meterRunType,this.meterType,this.nowUnit.id,this.deviceNos,this.ownerName,this.state,this.datetimeValue[0],this.datetimeValue[1],this.accountType,respon => {
        //   saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
        // })
      },
      // 切换每页显示条数
      pageSizeChange (pageSize) {
        this.pageIndex=1
        this.pageSize=pageSize
        this.getDataList()
      },
      // 切换页码
      jumpToPage (pageIndex) {
        this.pageIndex=pageIndex
        this.getDataList()
      },
    }
  }
</script>

<style scoped>
  .searchContainer {
    padding: 10px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .searchContainer>div {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 0;
  }

  .searchContainer label {
    margin-right: 6px;
  }

  .searchContainer input {
    border-color: #DCDFE6;
    min-width: 130px;
    height: 36px;
    box-sizing: border-box;
    margin-right: 10px;
  }

  .searchContainer>>>.selection-body {
    display: inline-flex;
    padding: 0;
    margin-right: 20px;
  }

  .searchContainer>>>.selection>p {
    line-height: 34px;
    height: 34px;
    padding: 0;
  }

  .selectDateTime {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 176px;
    height: 34px;
    padding: 0 6px;
    background: #FFFFFF;
    border-radius: 6px;
    border: solid 1px #DCDFE6;
    margin-right: 20px;
  }

  .selectDateTime>span {
    width: 140px;
    line-height: 34px;
    height: 100%;
    cursor: pointer;
  }

  .selectDateTime>img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .searchContainer>button {
    height: 36px;
    background-color: #409EFF;
    color: #FFFFFF;
    padding: 0 18px;
    margin-left: 10px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .infoListContainer {
    padding: 0 0 20px 20px;
    height: calc(100% - 76px);
  }

  .infoListContainer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .infoListContainer::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F0F0F0;
  }

  .infoListContainer::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-thumb {
    background-color: #CACACA;
  }

  .infoListContainer>div {
    width: calc(100% - 10px);
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87CF64;
    border-radius: 4px;
    color: #87CF64;
    background-color: #F0F9EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #F9A6A6;
    border-radius: 4px;
    color: #F9A6A6;
    background-color: #FEF1F1;
    line-height: 28px;
    padding: 0 6px;
  }

  .waitStatus {
    display: inline-block;
    border: solid 1px #E6A23C;
    border-radius: 4px;
    color: #E6A23C;
    background-color: #FDF6EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .normalStatus:hover,
  .wrongStatus:hover,
  .waitStatus:hover {
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
  }

  .operateBtn {
    display: inline-block;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 6px;
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
    margin-right: 8px;
    cursor: pointer;
  }

  .noDrop {
    cursor: no-drop !important;
  }

  .marginRightNone {
    margin-right: 0;
  }

  @media screen and (max-width: 1600px) {
    .searchContainer label {
      display: block;
      margin-right: 0;
    }

    .infoListContainer {
      height: calc(100% - 96px);
    }
  }
</style>